import React from "react";
import cs from "classnames";
import { useTranslation } from "react-i18next";
import { useProductSingleContext } from "../../lib/context/ProductSingleContext/ProductSingleContext";

import { ColorBoxes } from "../ProductSingleVariations/ProductSingleVariations";

export const ProductSimpleAttributes = () => {
  const { t } = useTranslation();
  const { product } = useProductSingleContext();
  const attributes = product?.attributes?.nodes.filter((item: any) => {
    if (item.name === "Madhesia") {
      return item.options[0] !== "0";
    }

    return item.name !== "Gjinia";
  });

  return (
    <div className="ProductSimpleAttributes">
      {attributes?.map((attr: any) => {
        const isColorAttribute = attr.name === "Ngjyra";
        const hasOptions = attr.options;

        if (!hasOptions) return null;

        return (
          <div
            key={`${attr.name}-single-variations`}
            className={cs(
              "ProductSingle__content__variations",
              "justify-content-between"
            )}
          >
            <div className="d-flex align-items-center">
              <span className="label">{t(attr.name)}</span>
              {isColorAttribute ? (
                <ColorBoxes
                  name={attr.name}
                  onClick={() => {}}
                  options={attr.options}
                />
              ) : (
                <span>{attr?.options?.join(", ")}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
